import React from 'react'
import {Container, CloseButton, Button, Row, Col} from 'react-bootstrap' 
import { useHistory } from 'react-router';
const Section = () => {

    const history = useHistory();
//
    return (
        <div>
            name
            Author
            revision num            

            <td><Button onClick={ (e) => click(sections[section]._id) } >+</Button></td>
            <td><Button>Update</Button></td>
            <CloseButton onClick={() => history.goBack()}/>

            <iframe src='https://view.officeapps.live.com/op/embed.aspx?src=http://machgroup.co.uk/test.doc' width="100%" height="768" frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
            <iframe src="https://docs.google.com/gview?url=http://remote.url.tld/path/to/document.doc&embedded=true"></iframe>
   


        </div>
    )
}
export default Section
